import { Controller } from "@hotwired/stimulus"

// Usage:
// <div data-controller="tabs">
//   <button data-action="tabs#show" data-tabs-target="tab" data-tab="personal">Personal</button>
//   ...
//   <div data-tabs-target="panel" data-tab-panel="personal">...</div>
//   ...
// </div>

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.showActiveTab()
  }

  show(event) {
    const tab = event.currentTarget.dataset.tab
    this.tabTargets.forEach(t => {
      t.classList.toggle('border-blue-600', t.dataset.tab === tab)
      t.classList.toggle('text-blue-600', t.dataset.tab === tab)
      t.classList.toggle('border-transparent', t.dataset.tab !== tab)
      t.classList.toggle('text-gray-500', t.dataset.tab !== tab)
      t.setAttribute('aria-selected', t.dataset.tab === tab ? 'true' : 'false')
    })
    this.panelTargets.forEach(p => {
      p.classList.toggle('hidden', p.dataset.tabPanel !== tab)
      p.classList.toggle('block', p.dataset.tabPanel === tab)
    })
  }

  showActiveTab() {
    // Show the first tab by default if none is active
    let activeTab = this.tabTargets.find(t => t.classList.contains('border-blue-600'))
    if (!activeTab && this.tabTargets.length > 0) {
      this.tabTargets[0].click()
    }
  }
} 